import { CdkPortal } from '@angular/cdk/portal';
import { Directive, Inject, InjectionToken, Optional, TemplateRef, ViewContainerRef } from '@angular/core';

/**
 * Injection token that can be used to reference instances of `MatTabLabel`. It serves as
 * alternative token to the actual `MatTabLabel` class which could cause unnecessary
 * retention of the class and its directive metadata.
 */
export const MAT_TAB_LABEL = new InjectionToken<MatTabLabelDirective>('MatTabLabel');

/**
 * Used to provide a tab label to a tab without causing a circular dependency.
 */
export const MAT_TAB = new InjectionToken<any>('MAT_TAB');

/**
 * Used to flag tab labels for use with the portal directive
 */
@Directive({
  selector: '[app-mat-tab-label], [appMatTabLabel]',
  providers: [{ provide: MAT_TAB_LABEL, useExisting: MatTabLabelDirective }],
})
export class MatTabLabelDirective extends CdkPortal {
  constructor(
    templateRef: TemplateRef<any>,
    viewContainerRef: ViewContainerRef,
    @Inject(MAT_TAB) @Optional() public _closestTab: any,
  ) {
    super(templateRef, viewContainerRef);
  }
}
